import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import NewsCard from '../components/NewsCard';
import SubscriptionForm from '../components/SubscriptionForm';
import Modal from '../components/Modal';
import CookieBanner from '../components/CookieBanner';
import { getFeaturedArticle } from '../newsData';
import newsArticles from '../newsData';

const Home = () => {
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useState(false);
  const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);

  const featuredArticle = getFeaturedArticle();
  const displayedArticles = newsArticles.slice(0, 9);

  const handleSubscribeClick = () => {
    setIsSubscribeModalOpen(true);
  };

  const handleSubscriptionSuccess = () => {
    setIsSubscribeModalOpen(false);
    setIsThankYouModalOpen(true);
  };

  const closeThankYouModal = () => {
    setIsThankYouModalOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header onSubscribeClick={handleSubscribeClick} />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <Hero article={featuredArticle} />

        {/* News Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-8 md:mb-12">
            Latest News
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {displayedArticles.map((article) => (
              <NewsCard key={article.article_id} article={article} />
            ))}
          </div>
        </section>

        {/* CTA Subscription Section */}
        <section className="bg-primary-600 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Stay Updated with Our Newsletter
            </h2>
            <p className="text-primary-100 mb-8 text-lg">
              Get the latest news and insights delivered directly to your inbox
            </p>
            <div className="max-w-md mx-auto">
              <SubscriptionForm onSubmit={handleSubscriptionSuccess} />
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Subscribe Modal */}
      <Modal
        isOpen={isSubscribeModalOpen}
        onClose={() => setIsSubscribeModalOpen(false)}
        title="Subscribe to Our Newsletter"
      >
        <SubscriptionForm onSubmit={handleSubscriptionSuccess} />
      </Modal>

      {/* Thank You Modal */}
      <Modal
        isOpen={isThankYouModalOpen}
        onClose={closeThankYouModal}
        title="Thank You for Subscribing!"
      >
        <p className="mb-6">
          Now you will receive the most up-to-date news.
        </p>
        <button
          onClick={closeThankYouModal}
          className="btn-primary w-full"
        >
          OK
        </button>
      </Modal>

      <CookieBanner />
    </div>
  );
};

export default Home;
